import { Head, Link } from '@inertiajs/react'
import { HomeMark } from '../../shared/HomeMark.jsx'
import { withSiteFooter } from '../../shared/SiteFooter.jsx'

// An invitation link that has expired or been used. Used is the common case:
// the link works once, because setting the password changes what it is keyed
// on. Somebody who already set a password signs in; somebody who never did can
// set one through the reset link, which reaches the same account.
export default function InvitationExpired() {
  return (
    <>
      <Head title="Invitation link" />
      <main className="mx-auto flex min-h-screen w-full max-w-md flex-col justify-center gap-8 px-6 py-16">
        <HomeMark />
        <div className="flex flex-col gap-3">
          <h1 className="page-title">This link has been used or has expired</h1>
          <p className="text-[15px] text-[color:var(--text-body)]">
            If you have set a password, <Link href="/session/new">sign in</Link>. If not,{' '}
            <Link href="/passwords/new">choose one here</Link> with the address the invitation was sent to.
          </p>
        </div>
      </main>
    </>
  )
}

InvitationExpired.layout = withSiteFooter
